'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  '3d': '3d',
  'access-accessibility': 'accès accessibilité',
  'access-ad': 'accès ad',
  'access-assist-listening': 'accès assistance audio',
  'access-braille': 'accès braille',
  'access-sign': 'accès langage des signes',
  'access-tty': 'accès tty',
  'access-volume-control': 'accès contrôle de volume',
  'access-wheelchair-active': 'accès chaise-roulante active',
  'access-wheelchair': 'accès chaise-roulante',
  'achievement': 'réussite',
  'action': 'action',
  'actions': 'actions',
  'add-circle': 'cercle d\'ajout',
  'add': 'ajout',
  'aggregate': 'aggrégation',
  'aid': 'soin',
  'alarm': 'alarme',
  'alert': 'alerte',
  'analytics': 'analyse',
  'announce': 'annonce',
  'apps': 'applications',
  'archive': 'archive',
  'article': 'article',
  'ascend': 'ascendant',
  'attachment': 'joint',
  'back-ten': 'retour dix',
  'bar-chart': 'diagramme  à bande',
  'basket': 'panier',
  'blog': 'blog',
  'book': 'livre',
  'bookmark': 'signet',
  'bottom-corner': 'coin inférieur',
  'brand-apple-app-store': 'étiquette apple app store',
  'brand-codepen-edit': 'étiquette codepen edit',
  'brand-codepen-try': 'étiquette codepen try',
  'brand-google-play': 'étiquette google play',
  'brand-grommet-outline': 'étiquette grommet outline',
  'brand-grommet-path': 'étiquette grommet path',
  'brand-hpe-element-outline': 'étiquette hpe element outline',
  'brand-hpe-element-path': 'étiquette hpe element path',
  'brand-hpe-labs-insignia-outline': 'étiquette hpe labs insignia outline',
  'brand-hpe-labs-insignia': 'étiquette hpe labs insignia',
  'brand-hpe-stack-centered': 'étiquette hpe stack centered',
  'brand-hpe-stack': 'étiquette hpe stack',
  'briefcase': 'porte document',
  'brush': 'brosse',
  'bug': 'insecte',
  'bundle': 'paquet',
  'business-service': 'service d\'affaire',
  'calculator': 'calculatrice',
  'calendar': 'calendrier',
  'camera': 'camera',
  'capacity': 'capacité',
  'car': 'voiture',
  'caret-down': 'caret bas',
  'caret-next': 'caret suivant',
  'caret-previous': 'caret précédant',
  'caret-up': 'caret haut',
  'cart': 'panier',
  'catalog': 'catalogue',
  'chapter-add': 'ajout de chapitre',
  'chapter-next': 'chapitre suivant',
  'chapter-previous': 'chapitre précédent',
  'chat': 'clavardage',
  'checkbox-selected': 'case sélectionnée',
  'checkbox': 'case de sélection',
  'checkmark': 'crochet',
  'circle-information': 'cercle d\'information',
  'circle-play': 'cercle play',
  'circle-question': 'cercle question',
  'clear-option': 'option nettoyer',
  'clear': 'nettoyer',
  'cli': 'cli',
  'clipboard': 'presse papier',
  'clock': 'horloge',
  'clone': 'clône',
  'close': 'fermer',
  'closed-caption': 'sous-titrage',
  'cloud-computer': 'ordinateur du nuage',
  'cloud-download': 'téléchargement du nuage',
  'cloud-software': 'logiciel du nuage',
  'cloud-upload': 'téléchargement sur le nuage',
  'cloud': 'nuage',
  'cluster': 'cluster',
  'code': 'code',
  'columns': 'colonnes',
  'compare': 'comparaison',
  'compass': 'boussole',
  'compliance': 'conformité',
  'configure': 'configuration',
  'connect': 'connexion',
  'contact-info': 'info du contact',
  'contact': 'contact',
  'contract': 'contrat',
  'copy': 'copie',
  'credit-card': 'carte de crédit',
  'cube': 'cube',
  'cubes': 'cubes',
  'currency': 'monnaie',
  'cursor': 'curseur',
  'cut': 'couper',
  'cycle': 'cycle',
  'dashboard': 'tableau de bord',
  'database': 'base de données',
  'deliver': 'livraison',
  'deploy': 'déployer',
  'descend': 'descendant',
  'desktop': 'ordinateur',
  'detach': 'disjoint',
  'diamond': 'diamand',
  'directions': 'directions',
  'dislike': 'je n\'aime pas',
  'document-cloud': 'fichier du nuage',
  'document-config': 'fichier de config',
  'document-csv': 'fichier csv',
  'document-download': 'téléchargement de fichier',
  'document-excel': 'fichier excel',
  'document-exe': 'fichier exe',
  'document-image': 'fichier d\'image',
  'document-locked': 'fichier vérouillé',
  'document-missing': 'fichier manquant',
  'document-notes': 'fichier de notes',
  'document-outlook': 'fichier outlook',
  'document-pdf': 'fichier pdf',
  'document-performance': 'fichier de performance',
  'document-ppt': 'fichier ppt',
  'document-rtf': 'fichier rtf',
  'document-sound': 'fichier audio',
  'document-store': 'fichier de sauvegarde',
  'document-test': 'fichier de test',
  'document-threat': 'fichier dangereux',
  'document-time': 'historique du fichier',
  'document-transfer': 'transfère de fichier',
  'document-txt': 'fichier txt',
  'document-update': 'mise à jour de fichier',
  'document-upload': 'téléversement de fichier',
  'document-user': 'fichier utilisateur',
  'document-verified': 'fichier vérifié',
  'document-video': 'fichier video',
  'document-windows': 'fichier windows',
  'document-word': 'fichier word',
  'document-zip': 'fichier zip',
  'document': 'fichier',
  'domain': 'domaine',
  'down': 'bas',
  'download': 'télécharger',
  'drag': 'glisser',
  'drive-cage': 'cage de disque',
  'duplicate': 'dupliquer',
  'edit': 'éditer',
  'eject': 'éjecter',
  'empty-circle': 'cercle vide',
  'expand': 'agrandir',
  'fan': 'ventilateur',
  'fast-forward': 'avance rapide',
  'favorite': 'favorie',
  'filter': 'filtre',
  'finger-print': 'empreinte digitale',
  'flag': 'drapeau',
  'folder-cycle': 'dossier cyclique',
  'folder-open': 'dossier ouvert',
  'folder': 'dossier',
  'form-edit': 'éditer le formulaire',
  'forward-ten': 'avance dix',
  'gallery': 'galerie',
  'gamepad': 'mannette',
  'gift': 'cadeau',
  'globe': 'globe',
  'grid': 'grille',
  'group': 'groupe',
  'grow': 'pousser',
  'halt': 'arrêt',
  'help': 'aide',
  'history': 'historique',
  'home': 'maison',
  'host-maintenance': 'maintenance de l\'hôte',
  'host': 'hôte',
  'image': 'image',
  'impact': 'impacte',
  'in-progress': 'en cours',
  'inbox': 'boîte',
  'indicator': 'indicateurr',
  'info': 'info',
  'inherit': 'héritage',
  'inspect': 'inspecter',
  'install': 'installer',
  'integration': 'integration',
  'iteration': 'itération',
  'java': 'java',
  'language': 'langue',
  'launch': 'lancer',
  'layer': 'calque',
  'license': 'license',
  'like': 'j\'aime',
  'line-chart': 'diagramme à ligne',
  'link-bottom': 'lien inférieur',
  'link-down': 'lien vers le bas',
  'link-next': 'lien suivant',
  'link-previous': 'lien précédent',
  'link-top': 'lien vers le haut',
  'link-up': 'lien supérieur',
  'link': 'lien',
  'local': 'locale',
  'location-pin': 'point de localisation',
  'location': 'localisation',
  'lock': 'verrou',
  'login': 'connexion',
  'logout': 'déconnexion',
  'magic': 'magie',
  'mail-option': 'option de courriel',
  'mail': 'courriel',
  'manual': 'manuel',
  'map-location': 'carte localisation',
  'map': 'carte',
  'menu': 'menu',
  'microphone': 'microphone',
  'money': 'argent',
  'monitor': 'moniteurr',
  'more': 'plus',
  'multiple': 'multiple',
  'navigate': 'naviguer',
  'new-window': 'nouvelle fenêtre',
  'new': 'nouveau',
  'next': 'suivant',
  'nodes': 'noeuds',
  'note': 'note',
  'notes': 'notes',
  'notification': 'notification',
  'object-group': 'objet groupé',
  'object-ungroup': 'objet séparé',
  'optimize': 'optimiser',
  'organization': 'organisation',
  'overview': 'aperçu',
  'pan': 'croix directionnelle',
  'pause-fill': 'pause pleine',
  'pause': 'pause',
  'personal-computer': 'ordinateur personnel',
  'pie-chart': 'diagramme en pointe de tarte',
  'pin': 'point',
  'plan': 'plan',
  'platform-amazon': 'platforme amazon',
  'platform-android': 'platforme android',
  'platform-apple': 'platforme apple',
  'platform-archlinux': 'platforme archlinux',
  'platform-aruba': 'platforme aruba',
  'platform-centos': 'platforme centos',
  'platform-chrome': 'platforme chrome',
  'platform-cloudlinux': 'platforme cloudlinux',
  'platform-debian': 'platforme debian',
  'platform-docker': 'platforme docker',
  'platform-dos': 'platforme dos',
  'platform-dropbox': 'platforme dropbox',
  'platform-edge': 'platforme edge',
  'platform-fedora': 'platforme fedora',
  'platform-firefox': 'platforme firefox',
  'platform-freebsd': 'platforme freebsd',
  'platform-google': 'platforme google',
  'platform-hadoop': 'platforme hadoop',
  'platform-heroku': 'platforme heroku',
  'platform-horton': 'platforme horton',
  'platform-hp': 'platforme hp',
  'platform-hpi': 'platforme hpi',
  'platform-internet-explorer': 'platforme internet explorer',
  'platform-java': 'platforme java',
  'platform-mandriva': 'platforme mandriva',
  'platform-mysql': 'platforme mysql',
  'platform-norton': 'platforme norton',
  'platform-onedrive': 'platforme onedrive',
  'platform-opera': 'platforme opera',
  'platform-oracle': 'platforme oracle',
  'platform-pied-piper': 'platforme pied piper',
  'platform-raspberry': 'platforme raspberry',
  'platform-reactjs': 'platforme reactjs',
  'platform-redhat': 'platforme redhat',
  'platform-safari-option': 'platforme safari option',
  'platform-safari': 'platforme safari',
  'platform-sco': 'platforme sco',
  'platform-solaris': 'platforme solaris',
  'platform-suse': 'platforme suse',
  'platform-swift': 'platforme swift',
  'platform-turbolinux': 'platforme turbolinux',
  'platform-ubuntu': 'platforme ubuntu',
  'platform-unixware': 'platforme unixware',
  'platform-vmware': 'platforme vmware',
  'platform-windows-legacy': 'platforme windows legacy',
  'platform-windows': 'platforme windows',
  'play-fill': 'play plein',
  'play': 'play',
  'power': 'démarrer',
  'previous': 'précédent',
  'print': 'imprimer',
  'radial-selected': 'sélecteur radial',
  'radial': 'radial',
  'refresh': 'rafraîchir',
  'resources': 'ressources',
  'resume': 'résumé',
  'revert': 'inverser',
  'rewind': 'rembobinner',
  'risk': 'risque',
  'robot': 'robot',
  'rss': 'rss',
  'run': 'course',
  'satellite': 'satellite',
  'save': 'sauvegarde',
  'scan': 'scan',
  'schedule-new': 'nouvel horaire',
  'schedule-play': 'horaire de jeu',
  'schedule': 'horaire',
  'schedules': 'horaires',
  'scorecard': 'tableau de point',
  'search-advanced': 'recherche avancée',
  'search': 'recherche',
  'secure': 'sécuritaire',
  'select': 'sélecteur',
  'selection': 'sélection',
  'send': 'envoie',
  'server-cluster': 'grappe de serveur',
  'server': 'serveur',
  'servers': 'serveurs',
  'service-play': 'service de jeu',
  'services': 'services',
  'settings-option': 'option de paramètre',
  'share': 'partager',
  'shield-security': 'bouclier de sécurité',
  'shield': 'bouclier',
  'shift': 'interchanger',
  'sidebar': 'barre latérale',
  'social-amazon': 'social amazon',
  'social-amex': 'social amex',
  'social-bitcoin': 'social bitcoin',
  'social-codepen': 'social codepen',
  'social-creative-commons': 'social creative commons',
  'social-dropbox': 'social dropbox',
  'social-facebook-option': 'social facebook option',
  'social-facebook': 'social facebook',
  'social-github': 'social github',
  'social-google-plus': 'social google plus',
  'social-google-wallet': 'social google wallet',
  'social-instagram': 'social instagram',
  'social-linkedin-option': 'social linkedin option',
  'social-linkedin': 'social linkedin',
  'social-mail': 'social mail',
  'social-mastercard': 'social mastercard',
  'social-medium': 'social medium',
  'social-paypal': 'social paypal',
  'social-pinterest': 'social pinterest',
  'social-product-hunt': 'social product hunt',
  'social-reddit': 'social reddit',
  'social-skype': 'social skype',
  'social-slack': 'social slack',
  'social-snapchat': 'social snapchat',
  'social-square': 'social square',
  'social-stack-overflow': 'social stack overflow',
  'social-stripe': 'social stripe',
  'social-tumblr': 'social tumblr',
  'social-twitter': 'social twitter',
  'social-vimeo': 'social vimeo',
  'social-vine': 'social vine',
  'social-visa': 'social visa',
  'social-wordpress': 'social wordpress',
  'social-youtube': 'social youtube',
  'sort': 'classer',
  'split': 'division',
  'splits': 'divisions',
  'stakeholder': 'partenaire',
  'standards-3d-effects': 'effets 3d standards',
  'standards-connectivity': 'standards de connectivité',
  'standards-css3': 'standards de css3',
  'standards-device': 'standards d\'appariels',
  'standards-fireball': 'standards boule de feux',
  'standards-html5': 'standards html5',
  'standards-multimedia': 'standards multimédia',
  'standards-offline-storage': 'standards d\'entreposage hors ligne',
  'standards-performance': 'standards de performances',
  'standards-sematics': 'standards sémantique',
  'star-half': 'demi étoile',
  'star': 'étoile',
  'steps': 'étape',
  'stop-fill': 'stop plein',
  'stop': 'stop',
  'storage': 'entreposage',
  'street-view': 'vue urbaine',
  'subtract-circle': 'cercle de soustraction',
  'subtract': 'soustraction',
  'support': 'support',
  'sync': 'synchroniser',
  'system': 'système',
  'table-add': 'ajout de tableau',
  'table': 'tableau',
  'tag': 'étiquette',
  'target': 'cible',
  'task': 'tâche',
  'tasks': 'tâches',
  'technology': 'technologie',
  'template': 'modèle',
  'terminal': 'terminale',
  'test-desktop': 'test ordinateur',
  'test': 'test',
  'text-wrap': 'encadrer par le texte',
  'threats': 'dangers',
  'ticket': 'billets',
  'tools': 'outils',
  'tooltip': 'indication',
  'top-corner': 'coin supérieur',
  'transaction': 'transaction',
  'trash': 'corbeille',
  'tree': 'arbre',
  'trigger': 'gchette',
  'trophy': 'trophé',
  'troubleshoot': 'dépannage',
  'unlink': 'délier',
  'unlock': 'déverrouiller',
  'up': 'haut',
  'update': 'mise à jours',
  'upgrade': 'améliorer',
  'upload': 'téléverser',
  'user-add': 'ajout utilisateur',
  'user-admin': 'utilisateur administratif',
  'user-expert': 'utilisateur expert',
  'user-female': 'utilisateur femelle',
  'user-manager': 'utilisateur manager',
  'user-new': 'nouvel utilisateur',
  'user-police': 'utilisateur policier',
  'user-settings': 'option d\'utilisateur',
  'user-worker': 'utilisateur travailleur',
  'user': 'utilisateur',
  'validate': 'valider',
  'video': 'vidéo',
  'view': 'vue',
  'virtual-machine': 'machine virtuelle',
  'vm-maintenance': 'vm en maintenance',
  'volume-low': 'volume bas',
  'volume-mute': 'volume en sourdine',
  'volume': 'volume',
  'vulnerability': 'vulnerabilité',
  'waypoint': 'direction',
  'workshop': 'atelier',
  'zoom-in': 'zoom avant',
  'zoom-out': 'zoom arrirère'
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/grommet/messages/icons/fr-FR.js
// module id = 104
// module chunks = 0